import { Letter } from 'state/letter/types'

import { CellProps } from 'components/ui'

import { Wrapper, Title, Value } from '../Style'

export function Location({ row }: CellProps<Letter>) {
  const { city, country } = row.original

  return (
    <Wrapper area='Location'>
      <Title>Location</Title>
      <Value>
        {city}, {country}
      </Value>
    </Wrapper>
  )
}
